module.exports = __webpack_public_path__ + "static/media/about-img.9815b04a.png";